import { default as BaseServices } from '../../../../PlanForm/GroupPlan/ProductPricings/Services';

const AddServices = () => {
  return <BaseServices ServicesHeader={() => 'Add Services'} />;
};

export default AddServices;
